<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">List of announcements</p>
      </div>
      <transition>
        <div v-if="delete_success" class="bg-green-200">
          <p>{{ delete_success }}</p>
        </div>
        <div v-if="delete_error" class="bg-primary">
          <p>{{ delete_error }}</p>
        </div>
      </transition>

      <div class="flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>

        <div class="flex flex-wrap whitespace-nowrap gap-2">
          <button
            @click="showAddAnnouncemnt = true"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/add.svg" />
            <i class="fi fi-sr-plus-small"></i>
            Add
          </button>
        </div>
      </div>
      <div class="">
        <div class="">
          <el-tabs
            type="border-card"
            v-model="activeTab"
            @tab-click="handleTabClick"
          >
            <el-tab-pane
              v-for="tab in tabs"
              :key="tab"
              :label="tab"
              :name="tab"
            >
              <div class="">
                <ve-table
                  v-if="searchInput"
                  :columns="columns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                />

                <ve-table
                  :columns="columns"
                  :tableData="currentTableData"
                  v-if="!searchInput.length"
                >
                </ve-table>

                <div
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="flex flex-col justify-center items-center h-full mt-5"
                >
                  <el-empty
                    :image="getImage()"
                    :image-size="70"
                    description="No results"
                  ></el-empty>
                </div>

                <div class="max-h-screen" v-else>
                  <div
                    v-if="
                      filteredTableData.length == 0 && !loading && !get_error
                    "
                    class="flex flex-col justify-center items-center h-full mt-5"
                  >
                    <el-empty
                      :image="getImage()"
                      :image-size="70"
                      description="No Data"
                    ></el-empty>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!-- create -->
      <add-announcement
        @close="handleClose"
        :showAddAnnouncemnt="showAddAnnouncemnt"
        :reload="reload"
      ></add-announcement>
      <!-- Edit -->
      <edit-announcement
        @close="handleClose"
        :showEditAnnouncemnt="showEditAnnouncemnt"
        :reload="reload"
        :info="info"
      ></edit-announcement>
      <!-- delete -->
      <confirm-delete
        :callback="confirmDelete"
        :item="announcementName"
        :show-prompt="showDeletePrompt"
      >
      </confirm-delete>
    </div>
  </div>
</template>

<script>
import AddAnnouncement from "@/components/announcements/addAnnouncement.vue";
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import ConfirmDelete from "@/utils/confirmDelete.vue";
import EditAnnouncement from "@/components/announcements/editAnnouncement.vue";
import decryptData from "@/utils/decrypt";
export default {
  name: "Announcemnts",
  components: { AddAnnouncement, ConfirmDelete, EditAnnouncement },
  data() {
    return {
      showDeletePrompt: false,
      showAddAnnouncemnt: false,
      showEditAnnouncemnt: false,
      delete_error: null,
      delete_success: null,
      announcementToDelete: null,
      announcementName: null,
      searchInput: "",
      info: null,
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      activeTab: "Published",
      tabs: ["Published", "Archived", "Draft"],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Title",
          key: "Title",
          title: "Title",
          align: "left",
          width: 150,
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title=""
              width="300"
              trigger="hover"
              content={row.Title}
            >
              <p slot="reference" class="cursor-pointer">
                {row.Title}
              </p>
            </el-popover>
          ),
        },
        {
          field: "Content",
          key: "Content",
          title: "Content",
          align: "left",
          width: 200,
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={row.Title}
              width="300"
              trigger="hover"
              content={row.Content}
            >
              <p slot="reference" class="cursor-pointer">
                {row.Content}
              </p>
            </el-popover>
          ),
        },
        {
          field: "Priority",
          key: "Priority",
          title: "Priority",
          renderBodyCell: ({ row }) => {
            if (row.Priority == 0) {
              return <p>Low</p>;
            } else if (row.Priority == 1) {
              return <p>Medium</p>;
            } else {
              return <p>High</p>;
            }
          },
        },
        {
          field: "PublicationDate",
          key: "PublicationDate",
          title: "Publication Date",
          renderBodyCell: ({ row }) =>
            moment(row.PublicationDate).format("DD/MM/YYYY"),
        },
        {
          field: "ExpirationDate",
          key: "ExpirationDate",
          title: "Expiration Date",
          renderBodyCell: ({ row }) =>
            moment(row.ExpirationDate).format("DD/MM/YYYY"),
        },
        {
          field: "CreatedBy",
          key: "CreatedBy",
          title: "CreatedBy",
          align: "left",
          renderBodyCell: ({ row }) =>
            decryptData(row.CreatedBy, this.$decryptionKey),
        },
        {
          field: "Status",
          key: "Status",
          title: "Status",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-3 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
      upcomingAnnouncements: [],
      draftAnnouncements: [],
      publishedAnnouncements: [],
      archivedAnnouncements: [],
    };
  },
  created() {
    this.getAnnouncements();
    this.setPageSizes();
  },
  watch: {
    activeTab: {
      handler: "updateFilteredTableData",
      immediate: true, // Invoke the handler immediately on component mount
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData based on activeTab
        return this.filterByActiveTab();
      } else {
        // Filter the tableData based on the search input and activeTab
        const searchInputLower = this.searchInput.toLowerCase();
        return this.filterByActiveTab().filter((item) => {
          // Check if the item matches the search input and the activeTab filter
          return (
            this.filterByActiveTab() &&
            Object.values(item).some((value) =>
              value?.toString().toLowerCase().includes(searchInputLower)
            )
          );
        });
      }
    },

    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.updateFilteredTableData().slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.updateFilteredTableData().length;
    },
  },
  methods: {
    getImage() {
      return require(`@/assets/icons/empty-folder-96.png`);
    },
    handleTabClick() {
      // console.log(tab);
    },
    updateFilteredTableData() {
      // Update the filteredTableData when activeTab changes
      return this.filterByActiveTab();
    },
    filterByActiveTab() {
      if (this.activeTab === "Published") {
        // Only return items with Status 'Published' and ExpirationDate greater than today
        return this.publishedAnnouncements;
      } else if (this.activeTab === "Archived") {
        // Only return items with Status 'Archived' and ExpirationDate less than today
        return this.archivedAnnouncements;
      } else if (this.activeTab === "Draft") {
        // Only return items with Status 'Draft'
        return this.draftAnnouncements;
      }
    },
    confirmDelete(isDeleteConfirmed) {
      if (isDeleteConfirmed) {
        this.deleteAnnouncement(this.announcementToDelete);
      } else {
        this.showDeletePrompt = false;
      }
    },

    handleDeleteButtonClick(announcement) {
      this.announcementToDelete = announcement;
      this.announcementName = announcement.Title;
      this.showDeletePrompt = true;
    },
    handleEditButtonClick(announcement) {
      this.info = announcement;
      this.showEditAnnouncemnt = true;
    },
    handleClose() {
      this.showAddAnnouncemnt = false;
      this.showEditAnnouncemnt = false;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    reload() {
      this.getAnnouncements();
      this.showEditAnnouncemnt = false;
    },

    // /{organization}/announcement/upcomming/v1/request
    getAnnouncements() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/announcement/upcomming/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.upcomingAnnouncements = response.data.Data;
              this.tableData = this.upcomingAnnouncements;

              const currentDate = new Date();

              this.archivedAnnouncements = this.upcomingAnnouncements.filter(
                (item) =>
                  item.Status === "Archived" ||
                  new Date(item.ExpirationDate) <= currentDate
              );

              this.publishedAnnouncements = this.upcomingAnnouncements.filter(
                (item) =>
                  item.Status === "Published" &&
                  new Date(item.ExpirationDate) > currentDate
              );

              this.draftAnnouncements = this.upcomingAnnouncements.filter(
                (item) => item.Status === "Draft"
              );
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/announcement/v1/delete
    deleteAnnouncement(announcement) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          AnnouncementId: announcement.Id,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/announcement/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.delete_success = response.data.StatusMessage;
              this.getAnnouncements();
              setTimeout(() => {
                this.delete_success = null;
              }, 2000);
            } else {
              this.delete_error = response.data.StatusMessage;
              setTimeout(() => {
                this.delete_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.delete_error = error.message;
            setTimeout(() => {
              this.delete_error = null;
            }, 2000);
          }
        );
    },
  },
};
</script>

<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
